import { motion } from "framer-motion"
import classNames from "classnames"
import { FastField as FormikField, useField, ErrorMessage } from "formik"
import { useAnimation } from "utils/useAnimation"

const Field = ({ name, label, placeholder, as = "text", className, ...props }) => {
  const FIELD_COMPONENTS = {
    text: "input",
    textarea: "textarea",
  }

  const As = FIELD_COMPONENTS[as]

  const [field, { error, touched }] = useField(name)
  const { variants } = useAnimation()

  return (
    <motion.div
      className={classNames("outline-none flex flex-col space-y-2 text-lg", className, error && touched && "border-red-500")}
      variants={variants}
    >
      <label className="font-medium">{label}</label>
      <div
        className={classNames(
          "relative flex justify-between gap-x-3 border-b border-grey-600 pt-1 pb-2 font-semibold",
          as === "textarea" && "border !p-4",
          error && touched && "border-red-500"
        )}
      >
        <FormikField
          name={name}
          placeholder={placeholder}
          className={classNames("flex-1 outline-none placeholder:font-medium", error && touched && "placeholder:text-red-500")}
          as={As}
          rows={4}
          {...field}
          {...props}
        />
        <ErrorMessage name={name} component="span" className={classNames("text-red-500", "text-sm self-center")} />
      </div>
    </motion.div>
  )
}

export default Field
